function initProductInfoTabs() {
  document.querySelectorAll('[data-product-info-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    if (!tabs.length || root.dataset.productInfoTabsBound === 'true') return;

    root.dataset.productInfoTabsBound = 'true';

    const activateTab = (tab) => {
      const panelId = tab.getAttribute('aria-controls');
      if (!panelId) return;

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.classList.toggle('is-active', isActive);
      });

      panels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductInfoTabs);
} else {
  initProductInfoTabs();
}

document.addEventListener('shopify:section:load', initProductInfoTabs);
